export * from "@lifecare-welfare/tinymce-enterprise";
import { default as tinymce } from "@lifecare-welfare/tinymce-enterprise";
export default tinymce;

import "@lifecare-welfare/tinymce-enterprise/models/dom/model";

import "@lifecare-welfare/tinymce-enterprise/langs/fi";
import "@lifecare-welfare/tinymce-enterprise/langs/sv_SE";
import "@lifecare-welfare/tinymce-enterprise/langs/nb_NO";

import "@lifecare-welfare/tinymce-enterprise/themes/silver/theme";

import "@lifecare-welfare/tinymce-enterprise/plugins/advlist/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/anchor/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/autolink/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/autoresize/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/autosave/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/directionality/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/editimage/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/fullscreen/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/image/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/insertdatetime/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/link/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/lists/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/nonbreaking/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/pagebreak/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/powerpaste/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/preview/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/save/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/searchreplace/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/table/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/visualblocks/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/visualchars/plugin";
import "@lifecare-welfare/tinymce-enterprise/plugins/wordcount/plugin";

import "@lifecare-welfare/tinymce-enterprise/icons/default/icons";

import "flow/bindings/inlineEditorBinding";
import "flow/bindings/editorBinding";

tinymce.overrideDefaults({
    ...tinymce.defaultOptions,
    text_patterns: [
        { start: "*", end: "*", format: ["italic"] },
        { start: "**", end: "**", format: ["bold"] },
        { start: "#", format: "h1", trigger: "space" },
        { start: "##", format: "h2", trigger: "space" },
        { start: "###", format: "h3", trigger: "space" },
        { start: "####", format: "h4", trigger: "space" },
        { start: "#####", format: "h5", trigger: "space" },
        { start: "######", format: "h6", trigger: "space" },
        { start: "1.", cmd: "InsertOrderedList", trigger: "space" },
        { start: "*", cmd: "InsertUnorderedList", trigger: "space" },
        // { start: "-", cmd: "InsertUnorderedList", trigger: "space" },
        { start: ">", cmd: "mceBlockQuote", trigger: "space" },
        { start: "---", cmd: "InsertHorizontalRule", trigger: "space" }
    ]
});
